import { requestHandler } from '../utils';
import { MessageProvider } from '../types/email';
import { AmbassadorHub } from '../types/ambassadorHub';
import {
    GetContractResponse,
    GetNeedsToAcceptContractResponse,
} from '../clientContracts/contract/contractDTO.js';
import { ContractType } from '../clientContracts/contract/entities.js';

export const clientStatusApi = {
    getEmailProviders: () => requestHandler<MessageProvider[]>('GET', '/oauth/email/providers'),

    getHubs: () => requestHandler<AmbassadorHub[]>('GET', '/api/ambassador-hubs'),

    getNeedsToAcceptTerms: () =>
        requestHandler<GetNeedsToAcceptContractResponse>(
            'GET',
            `/api/contract/needs-to-accept/TERMS_AND_CONDITIONS`,
        ),

    getTermsAcceptanceStatus: () =>
        requestHandler<boolean>('GET', `/api/contract/TERMS_AND_CONDITIONS`),

    getTermsDeclineStatus: () => requestHandler<boolean>('GET', `/api/contract/decline`),

    acceptTerms: (contractVersionId: number) =>
        requestHandler<boolean>('POST', `/api/contract/accept/terms`, { contractVersionId }),

    declineTerms: (contractVersionId: number) =>
        requestHandler<boolean>('POST', `/api/contract/decline`, { contractVersionId }),
    getTerms: (contractType: ContractType) =>
        requestHandler<GetContractResponse>('GET', `/api/contract/${contractType}`),
};
